import { Button } from 'common/components/Button/Button'
import { LoadingBox } from 'common/components/States/Loading/LoadingBox'
import { IPaginatedResponse } from 'common/types/api.types'
import { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { IJob } from '../../jobs.types'
import { CommunityJobsList } from './CommunityJobsList'

export interface IJobsListQuery {
  page: number
  queries: string[]
  nextQuery: string
  sortBy: string
  search: string | null
  totalItems: number
  loadedItems: number
  scrollPosition: number
  filters: {
    positions: string[]
    jobCategories: string[]
  }
}

interface IProps {
  query: IJobsListQuery
  setQuery: Dispatch<SetStateAction<IJobsListQuery>>
  isLoading: boolean
  data: IPaginatedResponse<IJob[]> | undefined
}

export const CommunityJobs = ({ query, setQuery, isLoading, data }: IProps) => {
  const onLoadMore = () => {
    if (query.nextQuery) {
      const nextPageUrl = new URL(query.nextQuery)
      const nextPage = nextPageUrl.searchParams.get('page') || 1
      const nextQuery = nextPageUrl.search

      setQuery((c) => ({ ...c, page: +nextPage, queries: [...c.queries, nextQuery] }))
    }
  }

  const pages: JSX.Element[] = []
  for (let i = 0; i < query.page; i++) {
    pages.push(<CommunityJobsList key={i} queryString={query.queries[i]} setQuery={setQuery} />)
  }
  const isInitialLoad = isLoading && query.page === 1
  return (
    <Div>
      <div className="job-list-container">
        {isInitialLoad && query.page === 1 && <LoadingBox size={48} minHeight="70vh" />}
        {pages}
      </div>

      {!isInitialLoad && (
        <div className="my-4 md:mb-1 px-6">
          {query.nextQuery ? (
            <Button size="large" className="w-full" variant="outline" onClick={onLoadMore} isLoading={isLoading}>
              Load more jobs
            </Button>
          ) : (
            !!data && <h2 className="text-sm text-center mt-4">No more jobs to load</h2>
          )}
        </div>
      )}
    </Div>
  )
}

export const Div = styled.div`
  .job-list-sticky-header {
    position: sticky;
    inset: 0 0 auto;
    width: 100%;
    padding: 0.5rem 1rem;
    background-color: #fff;
  }

  .job-list-container {
    position: relative;
    max-width: 100%;
    display: grid;
    gap: 2rem;
    padding-inline: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

    @media (min-width: 768px) {
      grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    }
  }
`
